import guides from "@volca/help/guides.json";
import type { HelpGuide } from "@/help/guides/types";

export const HELP_GUIDES = guides as Record<string, HelpGuide>;
